import reqwest from 'reqwest';
import { apiUrl } from './config';

export default {
  getContractSignature(data) {
    return reqwest({
      url: `${apiUrl}/official-api/api/contract/ess/detail/getContractSignature`,
      data,
    });
  },
};
